﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class FormFieldDefinition {
    constructor(init) {
        Object.assign(this, init);
    }
}
exports.FormFieldDefinition = FormFieldDefinition;
var FormFieldType;
(function (FormFieldType) {
    FormFieldType[FormFieldType["Text"] = 1] = "Text";
    FormFieldType[FormFieldType["Boolean"] = 2] = "Boolean";
    FormFieldType[FormFieldType["DateTime"] = 3] = "DateTime";
    FormFieldType[FormFieldType["Select"] = 4] = "Select";
})(FormFieldType || (FormFieldType = {}));
exports.FormFieldType = FormFieldType;
//# sourceMappingURL=FormFieldDefinition.js.map